module.exports = __webpack_public_path__ + "static/media/american-express.dd70043e.png";